import SimpleTable from '@/components/common/tables/simpleTable';
import { DocumentRecordData } from '@/interfaces';
import clsx from 'clsx';
import { format, parseISO } from 'date-fns';
import * as React from 'react';

export const FilesSent: React.FC<{
	isComplaint: boolean;
	versionRecords: DocumentRecordData[];
	isLoading: boolean;
	isASwitchedCase?: boolean;
}> = ({ isComplaint, versionRecords, isLoading, isASwitchedCase }) => {
	return (
		<div>
			<SimpleTable<
				DocumentRecordData & {
					isActive: boolean;
					index: number;
					isEmptyRow?: boolean;
				}
			>
				hideRowActions
				classNameContainer="!rounded-t-2xl !rounded-b-2xl shadow-none !pr-0 max-h-[400px] overflow-y-auto"
				classNameHeader="grid grid-cols-[2fr,1fr,1fr,1fr] !bg-gray-15"
				classNameRows={clsx(
					'grid grid-cols-[2fr,1fr,1fr,1fr] hover:!bg-transparent hover:!border-b-dark-10 hover:!border-t-dark-10 hover:!border-x-transparent !rounded-none',
					{
						'!bg-grey-2': isASwitchedCase,
					}
				)}
				classNameColumn="!py-1"
				classNameHead="!opacity-100"
				isLoading={isLoading}
				columns={[
					{
						header: 'File Name',
						content: (instance) =>
							instance.isEmptyRow ? (
								<>
									{/* Spacer to add a row height */}
									<br />
								</>
							) : (
								<span
									className={clsx(
										'text-xs',
										isASwitchedCase ? 'text-gray-0' : 'text-black'
									)}
								>
									{instance.file_name}
								</span>
							),
					},
					{
						header: 'Total Clients',
						content: (instance) =>
							instance.isEmptyRow ? null : (
								<span className="bg-grey-100 py-0.5 px-1.5 rounded-md text-xs">
									{instance.total_clients.toLocaleString('en-US')}{' '}
									{instance.total_clients === 1 ? 'Client' : 'Clients'}
								</span>
							),
					},
					{
						header: 'sent',
						content: (instance) =>
							instance.isEmptyRow ? null : (
								<span className="text-xs">
									{format(parseISO(instance.created_at), 'MMM dd, yyyy')}
									<br />
									<span className="text-grey-40">
										{format(parseISO(instance.created_at), 'HH:mm a')}
									</span>
								</span>
							),
					},
					{
						header: 'status',
						content: (instance) => {
							const isSuccess =
								!isASwitchedCase && (isComplaint || instance.index === 0);
							const isInactive =
								!isComplaint && !isASwitchedCase && instance.index !== 0;
							const isSwitched = isASwitchedCase;

							// let label = '';
							// if (isComplaint || isASwitchedCase) {
							// 	label = 'Sent';
							// } else {
							// 	label = instance.index === 0 ? 'Active' : 'Inactive';
							// }

							return instance.isEmptyRow ? null : (
								<div
									className={clsx(
										'text-xs py-1 px-[18px] rounded-lg w-[85px] text-center',
										{
											'bg-[#40BB7126] text-main-green': isSuccess,
											'bg-[#A5A5A526] text-grey-60': isSwitched,
											'bg-[#A5A5A526] text-grey-40': isInactive,
										}
									)}
								>
									Sent
									{/* {label} */}
								</div>
							);
						},
					},
				]}
				rows={
					versionRecords && versionRecords.length > 0
						? versionRecords.map((item, index) => ({
								...item,
								isActive: false,
								index,
						  }))
						: [
								{
									id: '',
									case_id: '',
									case_type: 'CLASS_ACTION',
									file_name: '',
									total_clients: 0,
									created_at: '',
									document_url: '',
									isActive: false,
									index: 0,
									isEmptyRow: true,
								},
						  ]
				}
				hasPagination={false}
			/>
		</div>
	);
};
